import { createFileRoute } from "@tanstack/react-router";
import ServiceAreaDetailPage from "@/pages/site/ServiceAreaDetailPage";

export const Route = createFileRoute("/service-areas/$slug")({
  component: () => <ServiceAreaDetailPage />,
});
